<template>
  <div class="docs">
    <div class="col-lg-12 m-0 p-0 my-3">
      <div
        class="col-md-12 jumbotron p-3"
        v-for="(data, index) in currentBooking"
        :key="index"
      >
        <p class="m-0 p-0 mb-2 header"><strong>ACTIVE BOOKING</strong></p>
        <p class="m-0 p-0">
          <span v-if="data.status == 3" class="badge badge-danger"
            >Expired</span
          >
          <span v-else-if="data.status == 1" class="badge badge-success"
            >Ongoing</span
          >
          <span v-else-if="data.status == 2" class="badge badge-success"
            >Completed</span
          >
          <span
            v-else-if="data.status == 0 && data.paymentStatus == 0"
            class="badge badge-danger"
            >Failed</span
          >
          <span
            v-else-if="data.status == 0 && data.paymentStatus == 1"
            class="badge badge-danger"
            >New</span
          >
          <span v-else-if="data.status == 6" class="badge badge-danger"
            >Dumped</span
          >
          <span v-else class="badge badge-success"
            >Status {{ data.status }}</span
          >
        </p>
        <div class="col-md-12 d-flex justify-content-between m-0 p-0">
          <p class="m-0 p-0"><span>Booking ID: </span>{{ data.bookingId }}</p>
          <p class="m-0 p-0">
            <span>Vehicle: </span
            ><span class="badge badge-secondary"
              >{{ data.modelName }} -{{ data.registrationNumber || "NA" }}</span
            >
          </p>
        </div>
        <div>
          <p class="m-0 p-0">
            <span>Booking Tenure: </span
            >{{ data.startDate | moment("DD/MM/YYYY") }} <span> - </span
            >{{ data.endDate | moment("DD/MM/YYYY") }}
            <span class="badge badge-secondary"
              >{{ noOfDays(data.startDate, data.endDate) }} days</span
            >
          </p>
        </div>
        <p class="m-0 p-0">
          <span>Payment Status: </span>
          <span class="badge badge-success" v-if="data.paymentStatus == 1"
            >Paid
          </span>
          <span class="badge badge-danger" v-else-if="data.paymentStatus == 0"
            >Pending</span
          >
          <span class="badge badge-danger" v-else>{{
            data.paymentStatus || "null"
          }}</span>
        </p>
        <p class="m-0 p-0">
          <span>Penaty: </span>
          <span class="badge badge-danger"
            >{{ data.penaltyCharge | currency }}
          </span>
        </p>
        <p class="m-0 p-0" style="">
          <span>{{ data.createdAt | moment("LLL") }}</span>
        </p>

        <div class="col-md-12 m-0 p-0 mt-3">
          <p class="header" @click="showExtension = !showExtension">
            <strong>EXTENSION HISTORY</strong>
            <span class="btn-link" style="cursor:pointer" v-if="showExtension">
              <i class="pl-2 fa fa-chevron-down" aria-hidden="true"></i
            ></span>
            <span class="btn-link" style="cursor:pointer" v-if="!showExtension">
              <i class="pl-2 fa fa-chevron-up" aria-hidden="true"></i
            ></span>
          </p>

          <table
            class="table"
            v-if="!getExtensionHistory(data.id).length == 0 && showExtension"
          >
            <thead class="thead-light">
              <tr>
                <th scope="col">Ex ID</th>
                <th scope="col">Amount</th>
                <th scope="col">Days</th>
                <th scope="COL">Penalty</th>
                <th scope="col">Date</th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="(data, index) in getExtensionHistory(data.id)"
                :key="index"
              >
                <th scope="row">
                  {{ data.extendId }}
                  <span class="badge badge-info">{{ data.source }}</span>
                </th>
                <td>
                  {{ data.amount | currency }}

                  <span
                    class="badge badge-success"
                    v-if="data.paymentStatus == 1"
                    >Paid
                  </span>
                  <span
                    class="badge badge-danger"
                    v-else-if="data.paymentStatus == 0"
                    >Pending</span
                  >
                </td>
                <td>
                  {{ data.noOfDays }}
                </td>
                <td>{{ data.penaltyCharge | currency }}</td>
                <td style="white-space: nowrap;">
                  {{ data.createdAt | moment("LLL") }}
                </td>
              </tr>
            </tbody>
          </table>
          <div v-if="getExtensionHistory(data.id).length == 0 && showExtension">
            <p>No Extension Payments received.</p>
          </div>
        </div>
        <div class="col-md-12 m-0 p-0 mt-3">
          <p class="header"><strong>AGENT ACTIVITY</strong></p>
          <div v-for="(activity, index) in data.agentActivity" :key="index">
            <span
              class="mb-2 badge badge-success"
              v-if="activity.type == 'new booking'"
            >
              Booking created by {{ activity.name }} on
              {{ activity.createdAt | moment("LLL") }}.
            </span>
            <span
              class="mb-2 badge badge-info"
              v-if="activity.type == 'first assigned'"
            >
              {{ activity.description }} by {{ activity.name }} on
              {{ activity.createdAt | moment("LLL") }}.
            </span>
            <span
              class="mb-2 badge badge-primary"
              v-if="activity.type == 'vehicle changed'"
            >
              {{ activity.description }} by {{ activity.name }} on
              {{ activity.createdAt | moment("LLL") }}.
            </span>
            <span
              class="mb-2 badge badge-danger"
              v-if="activity.type == 'Booking ended'"
            >
              {{ activity.description }} by {{ activity.name }} on
              {{ activity.createdAt | moment("LLL") }}.
            </span>
          </div>
          <div v-if="!data.agentActivity">
            <p>No agent activities for this booking.</p>
          </div>
        </div>
      </div>
      <div class="jumbotron p-3 m-0">
        <div class="col-md-12 mb-3 m-0 p-0">
          <p class="header"><strong>BOOKING HISTORY</strong></p>
          <input
            type="text"
            placeholder="searching booking ID, model name etc"
            v-model="searching"
            class="form-control"
          />
        </div>

        <div id="accordion">
          <div
            class="card mb-3"
            v-for="(data, index) in filteredList"
            :key="index"
          >
            <div class="card-header" :id="'heading' + index">
              <p class="m-0 p-0">
                <span v-if="data.status == 3" class="badge badge-danger"
                  >Expired</span
                >
                <span v-else-if="data.status == 1" class="badge badge-success"
                  >Ongoing</span
                >
                <span v-else-if="data.status == 2" class="badge badge-success"
                  >Completed</span
                >
                <span
                  v-else-if="data.status == 0 && data.paymentStatus == 0"
                  class="badge badge-danger"
                  >Failed</span
                >
                <span
                  v-else-if="data.status == 0 && data.paymentStatus == 1"
                  class="badge badge-danger"
                  >New</span
                >
                <span v-else-if="data.status == 6" class="badge badge-danger"
                  >Dumped</span
                >
                <span v-else class="badge badge-success"
                  >Status {{ data.status }}</span
                >
              </p>
              <h5 class="mb-0">
                <button
                  class="btn btn-link text-left collapsed w-100"
                  data-toggle="collapse"
                  :data-target="'#collapse' + index"
                  aria-expanded="true"
                  :aria-controls="index"
                  style="text-decoration:none"
                >
                  {{ data.bookingId }} - {{ data.modelName }} -{{
                    data.registrationNumber || "NA"
                  }}
                  <p class="m-0 p-0 labels">
                    <span>Booking Tenure: </span
                    >{{ data.startDate | moment("DD/MM/YYYY") }} <span> - </span
                    >{{ data.endDate | moment("DD/MM/YYYY") }}
                    <span class="badge badge-secondary"
                      >{{ noOfDays(data.startDate, data.endDate) }} days</span
                    >
                  </p>
                  <p class="m-0 p-0" style="">
                    <span
                      >Outreach status:
                      <span style="" class="badge badge-primary">{{
                        checkFunnel(data.flag)
                      }}</span>
                    </span>
                  </p>
                  <p class="m-0 p-0" style="">
                    <span>{{ data.createdAt | moment("LLL") }}</span>
                  </p>
                </button>
              </h5>
            </div>

            <div
              :id="'collapse' + index"
              class="collapse"
              :aria-labelledby="'heading' + index"
              data-parent="#accordion"
            >
              <div class="card-body">
                <div>
                  <p class="m-0 p-0 mb-2">
                    <strong><span>PAYMENTS</span></strong>
                  </p>
                  <p class="m-0 p-0">
                    <span>Rental Charge:</span>
                    <strong> {{ data.rentalCharge | currency }}</strong>
                  </p>
                  <p class="m-0 p-0">
                    <span>Payment Status: </span>
                    <span
                      class="badge badge-success"
                      v-if="data.paymentStatus == 1"
                      >Paid
                    </span>
                    <span
                      class="badge badge-danger"
                      v-else-if="data.paymentStatus == 0"
                      >Pending</span
                    >
                    <span class="badge badge-danger" v-else>{{
                      data.paymentStatus || "null"
                    }}</span>
                  </p>
                  <div class="col-md-12 m-0 p-0 d-flex justify-content-between">
                    <p class="m-0 p-0">
                      <span>Razorpay Order ID: </span
                      >{{ data.razorpay_order_id || "NA" }}
                    </p>
                    <p class="m-0 p-0">
                      <span>Razorpay Payment ID: </span
                      >{{ data.razorpay_payment_id || "NA" }}
                    </p>
                  </div>
                  <div class="col-md-12 m-0 p-0 d-flex justify-content-between">
                    <p class="m-0 p-0">
                      <span>Gpay ID: </span>{{ data.g_pay_id || "NA" }}
                    </p>
                    <p class="m-0 p-0">
                      <span>Simple ID: </span>{{ data.simpl_id || "NA" }}
                    </p>
                    <p class="m-0 p-0">
                      <span>Other ID: </span>{{ data.other_payment_id || "NA" }}
                    </p>
                  </div>
                </div>
                <!-- {{data.agentActivity}} -->
                <div class="mt-2">
                  <p class="m-0 p-0 mb-2">
                    <strong><span>OTHERS</span></strong>
                  </p>
                </div>
                <div class="col-md-12 m-0 p-0 d-flex justify-content-between">
                  <p class="m-0 p-0">
                    <span>Delivery Type: </span>
                    <span
                      class="badge badge-success"
                      v-if="data.deliveryType == 1"
                      >Home Delivery
                    </span>
                    <span
                      class="badge badge-success"
                      v-if="data.deliveryType == 0"
                      >Self Pickup</span
                    >
                  </p>
                  <p class="m-0 p-0">
                    <span>Helmet : </span>
                    <span
                      class="badge badge-success"
                      v-if="data.extraHelmet == 1"
                      >Yes
                    </span>
                    <span
                      class="badge badge-success"
                      v-if="data.extraHelmet == 0"
                      >No</span
                    >
                  </p>
                  <p class="m-0 p-0">
                    <span>Email Sent : </span>
                    <span
                      class="badge badge-success"
                      v-if="data.mailStatus == 1"
                      >Yes
                    </span>
                    <span
                      class="badge badge-success"
                      v-if="data.mailStatus == 0"
                      >No</span
                    >
                  </p>
                  <p class="m-0 p-0">
                    <span>Other ID: </span>{{ data.other_payment_id || "NA" }}
                  </p>
                </div>
                <div>
                  <p class="m-0 p-0">
                    <span>Delivery Address: </span
                    >{{ data.deliveryAddress || "NA" }}
                  </p>
                </div>
                <div class="col-md-12 m-0 p-0 mt-3">
                  <p class="header"><strong>EXTENSION HISTORY</strong></p>

                  <table
                    class="table"
                    v-if="!getExtensionHistory(data.id).length == 0"
                  >
                    <thead class="thead-light">
                      <tr>
                        <th scope="col">Ex ID</th>
                        <th scope="col">Amount</th>
                        <th scope="col">Days</th>
                        <th scope="COL">Penalty</th>
                        <th scope="col">Date</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        v-for="(data, index) in getExtensionHistory(data.id)"
                        :key="index"
                      >
                        <th scope="row">
                          {{ data.extendId }}
                          <span class="badge badge-info">{{
                            data.source
                          }}</span>
                        </th>
                        <td>
                          {{ data.amount | currency }}

                          <span
                            class="badge badge-success"
                            v-if="data.paymentStatus == 1"
                            >Paid
                          </span>
                          <span
                            class="badge badge-danger"
                            v-else-if="data.paymentStatus == 0"
                            >Pending</span
                          >
                        </td>
                        <td>
                          {{ data.noOfDays }}
                        </td>
                        <td>{{ data.penaltyCharge | currency }}</td>
                        <td style="white-space: nowrap;">
                          {{ data.createdAt | moment("LLL") }}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  <div v-if="getExtensionHistory(data.id).length == 0">
                    <p>No Extension Payments received.</p>
                  </div>
                </div>
                <div class="col-md-12 m-0 p-0 mt-3">
                  <p class="header"><strong>AGENT ACTIVITY</strong></p>
                  <div
                    v-for="(activity, index) in data.agentActivity"
                    :key="index"
                  >
                    <span
                      class="mb-2 badge badge-success"
                      v-if="activity.type == 'new booking'"
                    >
                      Booking created by {{ activity.name }} on
                      {{ activity.createdAt | moment("LLL") }}.
                    </span>
                    <span
                      class="mb-2 badge badge-info"
                      v-if="activity.type == 'first assigned'"
                    >
                      {{ activity.description }} by {{ activity.name }} on
                      {{ activity.createdAt | moment("LLL") }}.
                    </span>
                    <span
                      class="mb-2 badge badge-primary"
                      v-if="activity.type == 'vehicle changed'"
                    >
                      {{ activity.description }} by {{ activity.name }} on
                      {{ activity.createdAt | moment("LLL") }}.
                    </span>
                    <span
                      class="mb-2 badge badge-danger"
                      v-if="activity.type == 'Booking ended'"
                    >
                      {{ activity.description }} by {{ activity.name }} on
                      {{ activity.createdAt | moment("LLL") }}.
                    </span>
                  </div>
                  <div v-if="!data.agentActivity">
                    <p>No agent activities for this booking.</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            class="mt-5 col-md-12 text-center"
            v-if="bookingHistory.length == 0 && !makingAJAX"
          >
            <p>We didn't get any data.</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import json from "../../../../Inventory/flags";
const moment = require("moment");

export default {
  data() {
    return {
      flagsJson: json,
      searching: "",
      showExtension: true,
    };
  },
  created() {
    this.$store.state.customer_by_number = [];
    this.phone_number = this.$route.params.phone;
    this.cx_id = this.$route.params.cx_id;
    this.currentTab = this.$route.query.tab;
    if (this.phone_number) {
      this.$store.dispatch("get_booking_history", { id: this.cx_id });
      this.$store.dispatch("get_extend_payment_data", { id: this.cx_id });
    } else {
      this.showModal = true;
    }
  },
  methods: {
    getExtensionHistory(id) {
      return this.extendBookingHistory.filter((x) => {
        return x.bookingId == id;
      });
    },
    checkFunnel(id) {
      var x = this.flagsJson.filter((x) => {
        return x.flag == id;
      });
      return x[0].funnel + "-" + x[0].state;
    },
    noOfDays(start, end) {
      var startDate = moment(start);
      var endDate = moment(end);
      return endDate.diff(startDate, "days") || 0;
    },
  },
  computed: {
    makingAJAX() {
      return this.$store.state.makingAJAX;
    },
    bookingHistory() {
      return this.$store.state.bookingHistory;
    },
    extendBookingHistory() {
      return this.$store.state.extend_payment_data;
    },
    currentBooking() {
      var x = this.bookingHistory.filter((x) => {
        return x.status == 1 || x.status == 3;
      });
      return x;
    },
    filteredList() {
      return this.bookingHistory.filter((post) => {
        if (post.registrationNumber) {
          return (
            post.bookingId
              .toLowerCase()
              .includes(this.searching.toLowerCase()) ||
            post.modelName
              .toLowerCase()
              .includes(this.searching.toLowerCase()) ||
            post.registrationNumber
              .toLowerCase()
              .includes(this.searching.toLowerCase())
          );
        } else {
          return (
            post.bookingId
              .toLowerCase()
              .includes(this.searching.toLowerCase()) ||
            post.modelName.toLowerCase().includes(this.searching.toLowerCase())
          );
        }
      });
    },
  },
};
</script>

<style scoped>
.labels {
  font-size: 12px;
  color: gray;
}
p span:not(.badge) {
  color: gray;
}
.header {
  color: blue;
}
</style>
